import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const ACCOUNT_AVAILABLE_OAUTH_PROVIDERS_QUERY_KEY = 'account-available-oauth-providers';

export function useAccountAvailableOAuthProviders({
	impersonationContext,
	enabled,
	refetchOnWindowFocus,
	meta,
}: {
	impersonationContext?: Api.IImpersonationContext;
	enabled?: boolean;
	refetchOnWindowFocus?: boolean;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: 'account/oauth/providers',
				}),
				'GET'
			);
		},
		refetchOnWindowFocus,
		queryKey: [ACCOUNT_AVAILABLE_OAUTH_PROVIDERS_QUERY_KEY, impersonationContext],
		meta,
	});
}

export const invalidateAccountAvailableOAuthProvidersQuery = ({
	impersonationContext,
}: {
	impersonationContext: Api.IImpersonationContext;
}) =>
	reactQueryClient.invalidateQueries({ queryKey: [ACCOUNT_AVAILABLE_OAUTH_PROVIDERS_QUERY_KEY, impersonationContext] });
